import React from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import './navbar.css'
import { LinkContainer } from 'react-router-bootstrap';



function CakesByMaryNavbar () {



    return (
      <>
       <Navbar expand="lg" className="navbar-teal">
      <Container>
        <LinkContainer to="/">
          <Navbar.Brand>CakesByMary</Navbar.Brand>
        </LinkContainer>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <LinkContainer to="/">
              <Nav.Link>Home</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/faq">
              <Nav.Link>FAQ</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/flavors">
              <Nav.Link>Cake Flavors</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/policies">
              <Nav.Link>Payment Policy</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/contact">
              <Nav.Link>Availability/Order</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/login">
              <Nav.Link>Login</Nav.Link>
            </LinkContainer>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    </>
    )
}
export default CakesByMaryNavbar;